module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogSystemMsg",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": "系统消息",
      "visible": _vm.$store.state.Dialog.dialogName === _vm.dialogName
    }
  }, [(_vm.messageList.length > 0 && _vm.messageList != undefined) ? [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.messageList,
      "border": "",
      "stripe": "",
      "show-header": _vm.showHeader
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('span', [_vm._v(_vm._s(scope.row.createAt))])])]
      }
    }], null, false, 3422164152)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "140",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('span', [_vm._v(_vm._s(scope.row.title))])])]
      }
    }], null, false, 1325542025)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('span', [_vm._v(_vm._s(scope.row.content))])])]
      }
    }], null, false, 1437059008)
  })], 1)] : [_c('tr', [_c('td', [_vm._v("暂无系统消息")])])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-57f19503","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialogSystemMsg.vue
// module id = 599
// module chunks = 64